<template>
  <div>
    <ca-heading text="Cadastro de Função" />

    <ca-page>
      <ca-loader v-if="showLoading"></ca-loader>

      <ca-form
        v-else
        :key="formKey"
        :is-valid.sync="isFormValid"
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="CBO">
              <ca-search-select
                v-model="jobDescription.cbo"
                :selected-option="selectedCbo"
                :on-fetch="onFetch"
                :on-fetch-success="onFetchSuccess"
                :on-query-term-change="onQueryTermChanged"
                :on-query="onQuery"
                :on-query-success="onQuerySuccess"
                :on-change="refreshForm"
                required>
                <ca-option
                  v-for="value in cboData"
                  :key="value.codigo"
                  :value="value.codigo">
                  {{ `${value.codigo} - ${value.descricao}` }}
                </ca-option>
              </ca-search-select>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Descrição">
              <ca-input
                v-model="jobDescription.description"
                maxlength="100"
                required></ca-input>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col size="6">
            <ca-field label="CNPJ do Sindicato da Categoria">
              <cnpj-input v-model="jobDescription.categoryUnionCnpj"></cnpj-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Compartilhado">
              <ca-checkbox v-model="jobDescription.shared"></ca-checkbox>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button>
                Salvar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { initFormObject, getBoxInformationErrorMessage } from 'packages/common/utils';
import {
  getJobDescription, createNewJobDescription, editJobDescription, getCboOptions,
} from './jobDescriptionService';

export default {
  name: 'JobDescriptionsFormPage',
  props: {
    isModal: Boolean,
    isValid: Boolean,
    object: Object,
  },
  data() {
    return {
      formKey: 0,
      isFormValid: false,
      jobDescriptionId: this.$route.params.id,
      jobDescription: {
        ...initFormObject([{ statusEsocial: 'N' }]),
        descricao: '',
      },
      selectedCbo: {},
      cboSearchTerm: '',
      cboData: [],
      errorMessage: null,
    };
  },
  computed: {
    hasJobDescriptionId() {
      return this.jobDescriptionId;
    },
    showLoading() {
      return !this.isModal && this.hasJobDescriptionId && this.jobDescription.loading;
    },
    misc() {
      return this.$store.state.misc;
    },
  },
  watch: {
    isFormValid(isValid) {
      if (this.isModal) {
        this.$emit('update:isValid', isValid);
      }
    },
    jobDescription(value) {
      if (this.isModal) {
        this.$emit('update:object', value);
      }
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.hasJobDescriptionId && !this.isModal) {
        this.setJobDescription();
      }
      this.$store.dispatch('misc/getEsocialStatus');
    },
    async setJobDescription() {
      this.jobDescription = await getJobDescription(this.jobDescriptionId);

      getCboOptions(this.jobDescription.cbo)
        .then(this.onQuerySuccess);

      this.setSelectedCbo(this.jobDescription.cbo, this.jobDescription.descricao);
    },
    onQueryTermChanged(value) {
      this.cboSearchTerm = value;
    },
    onQuery() {
      return getCboOptions(this.cboSearchTerm);
    },
    onQuerySuccess(response) {
      this.cboData = response;
    },
    onFetch(value) {
      return getCboOptions(value);
    },
    onFetchSuccess(response) {
      const [{ descricao: description, codigo: code }] = response;
      this.setSelectedCbo(code, description);
      this.jobDescription.descricao = description;
    },
    setSelectedCbo(code, description) {
      this.selectedCbo = {
        value: code,
        label: `${code} - ${description}`,
      };
    },
    goBack() {
      this.$router.back();
    },
    onSubmit() {
      return this.hasJobDescriptionId
        ? editJobDescription(this.jobDescriptionId, this.jobDescription)
        : createNewJobDescription(this.jobDescription);
    },
    onSubmitSuccess() {
      this.goBack();
      this.$toaster.success('Dados salvos com sucesso');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    async refreshForm() {
      await this.$nextTick();
      this.formKey++;
    },
  },
};
</script>
